import React,{ Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from 'axios';
import { updateEditProductDetail } from "../../../actions/products";
import { showToastMessage } from "../../../actions/toastmessage";
import config from '../../../../config/config';
import SectionLabel from "../GroupingContainers/SectionLabel";
import ListItemSlider from "../GroupingContainers/LIstItemSlider";

/**
 * Enquiry Forms only use when sellOnline is false, 0 or null
 * @param - enquiryFormId - product enquiry form id or default form id gets from api
 */
const EnquiryForms = (props) => {
    const { enquiryFormId=null, updateEditProductDetail=null } = props;
    const [enquiryForms, setEnquiryForms] = useState([]);
    const [enquiryLabel, setEnquiryLabel] = useState('');
    const [enquiryFormList, toggleEnqFormList] = useState(false);

    useEffect(() => {
        axios.get(config.apiDomains[0] + '/vendorapis/supplierForm/supplierForm/getsupplierform')
            .then(response => {
                if (response.data.isSuccess) {
                    let forms = [], selected = 0, formname='';
                    response.data.data.map((cur, index) => {
                        let enquiry = {};
                        enquiry.label = cur.formName
                        enquiry.key = cur.id
                        forms.push(enquiry);
                        if(enquiryFormId && enquiryFormId == cur.id) {
                            selected = cur.id;
                            formname = cur.formName;
                        } else if (cur.default) {
                            selected = cur.id;
                            formname = cur.formName;
                        }
                    })
                    setEnquiryLabel(formname);
                    setEnquiryForms([...forms]);
                    updateEditProductDetail({
                        key: 'enquiryFormId',
                        value: selected
                    });
                }
            })
    }, []);

    const saveHandler = (data) => {
        updateEditProductDetail({
            key: 'enquiryFormId',
            value: data.key
        });
        setEnquiryLabel(data.label);
    }

    return (<Fragment>
            <SectionLabel
                styles={props.styles} 
                title={'Enquiry Form'}
                subTitle={enquiryLabel}
                onClick={() => enquiryForms.length ? toggleEnqFormList(true) : null} 
            />
            {enquiryForms.length && enquiryFormList ? <ListItemSlider
                sliderTitle="Select Enquiry Form"
                defaultSelectedKey={enquiryFormId}
                items={enquiryForms}
                onHidden={toggleEnqFormList}
                onSave={saveHandler}
            /> : null}
        </Fragment>
    );

}
const mapStateToProps = (state,props) => {
    return {
        ...props
    }
}
export default connect(mapStateToProps, {
    updateEditProductDetail,
    showToastMessage
})(EnquiryForms);